import { required } from "vuelidate/lib/validators";
const satdosyafirma = {
  data() {
    return {
      satdosyafirmaData: {
        Dosyaid: "",
        Firmaid: null,
        Degerlendirmeid: null,
        Kararid: null,
        Firmaturu: 0,
        Deleted: false,
      },
      FormDataType: {
        Firmaid: {
          FieldName: "Firmaid",
          Field: "treeselect",
          FieldTitle: this.$t("satdosyafirma.AddEdit.Firmaid"),
          FieldType: "text",
          ComboDataArray: [], 
        },
      },
    };
  },
  validations: {
    FormData: {
      Firmaid: { required },
    },
  },
  created() {
    
  },
};
export default satdosyafirma;
